import { WarningOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Table } from 'antd'
import React, { FunctionComponent } from 'react'

import {
  AuctionListingFilter,
  useAuctionMonitoringTabQuery,
} from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { ExportTableXlsxButton } from '../ExportTableXlsxButton/ExportTableXlsxButton'
import { TableItemsCount } from '../TableItemsCount/TableItemsCount'
import { TableSummaryExportProps } from '../TableSummaryExport/TableSummaryExport'

export interface AuctionMonitoringTableSummaryProps {
  total?: number
  totalColumn: number
  auctionListingFilter?: AuctionListingFilter
  summaryProps?: TableSummaryExportProps
}

const classNames = { body: 'max-w-xs' }

export const AuctionMonitoringTableSummary: FunctionComponent<AuctionMonitoringTableSummaryProps> =
  props => {
    const accountUserId = useAppSelector(state => state.myProfile.userId)
    const accountId = useAppSelector(state => state.myProfile.tenantId)

    const [dataSource, fetch] = useAuctionMonitoringTabQuery({
      pause: true,
      variables: {
        filter: props.auctionListingFilter,
        accountUserId,
        accountId,
        exportData: true,
      },
    })

    return (
      <Table.Summary.Row className="bg-[#fafafa]">
        <Table.Summary.Cell
          colSpan={props.totalColumn - 1}
          index={0}
          className="!py-2"
        >
          <TableItemsCount total={props.total || 0} />
        </Table.Summary.Cell>
        <Table.Summary.Cell colSpan={2} className="text-right" index={1}>
          {dataSource?.data?.allAuctionListings?.nodes?.length ? (
            <ExportTableXlsxButton
              dataSource={dataSource.data.allAuctionListings.nodes || []}
              url="auctionListing/auctionListingXlsx"
              fileName="Drazby"
              buttonText="Stáhnout .xlsx"
              icon
            />
          ) : (
            <Popconfirm
              title={
                dataSource.error
                  ? 'Při přípravě dat pro export nastala chyba. Chcete to zkusit znova?'
                  : 'V prvním kroku se zpracují data pro export, jakmile budou připravena, zobrazí se tlačítko pro stažení .xlsx souboru.'
              }
              onConfirm={fetch}
              classNames={classNames}
              okText={dataSource.error ? 'Zkusit znova' : 'Rozumím'}
              cancelText="Zavřít"
              placement="topRight"
            >
              <Button
                type="link"
                size="small"
                title="Exportovat tabulku do .xlsx (excel)"
                loading={dataSource.fetching}
                danger={!!dataSource.error}
                icon={dataSource.error ? <WarningOutlined /> : undefined}
              >
                {dataSource.error ? 'Export selhal' : 'Exportovat do XLSX'}
              </Button>
            </Popconfirm>
          )}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    )
  }
